// actions/healthcareProductActions.js
import { toast } from "react-toastify";
import * as api from "../api";
import {
  START_LOADING,
  END_LOADING,
  CREATE_PRODUCT_HEALTHCARE,
  UPDATE_PRODUCT_HEALTHCARE,
  DELETE_PRODUCT_HEALTHCARE,
  FETCH_PRODUCT_HEALTHCARE,
} from "../constants/actionTypes.js";

// Create Product
export const createHealthcareProduct =
  (productData, vendorId) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.apiCreateHealthcareProduct(productData);
      dispatch({ type: CREATE_PRODUCT_HEALTHCARE, payload: data.data });
      dispatch({ type: END_LOADING });
      toast.success(data.message);
      return data;
    } catch (error) {
      console.log(error.response?.data?.message || error.message);
      toast.error(error.response?.data?.message || error.message);
      dispatch({ type: END_LOADING });
      throw error;
    }
  };

// Fetch Product Details
export const fetchHealthcareProduct =
  (productId) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.apiFetchHealthcareProduct(productId);
      dispatch({ type: FETCH_PRODUCT_HEALTHCARE, payload: data });
      dispatch({ type: END_LOADING });
      return data;
    } catch (error) {
      console.error("Error fetching product:", error);
      toast.error(
        "Failed to fetch product: " +
          (error.response?.data?.message || error.message)
      );
      dispatch({ type: END_LOADING });
      throw error;
    }
  };

// Update Product
export const updateHealthcareProduct =
  (productId, updatedProductData) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.apiUpdateHealthcareProduct(
        productId,
        updatedProductData
      );
      dispatch({ type: UPDATE_PRODUCT_HEALTHCARE, payload: data.data });
      dispatch({ type: END_LOADING });
      toast.success("Product updated successfully!");
      return data;
    } catch (error) {
      console.error("Error updating product:", error);
      toast.error(
        "Failed to update product: " +
          (error.response?.data?.message || error.message)
      );
      dispatch({ type: END_LOADING });
      throw error;
    }
  };

// Delete Product
export const deleteHealthcareProduct =
  (productId, vendorId) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.apiDeleteHealthcareProduct(productId);
      dispatch({ type: DELETE_PRODUCT_HEALTHCARE, payload: productId });
      dispatch({ type: END_LOADING });
      toast.success(data.message);
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error(
        "Failed to delete product: " +
          (error.response?.data?.message || error.message)
      );
      dispatch({ type: END_LOADING });
    }
  };






